<template>
  <div class="p-grid title-block">
    <div class="p-col-5 title-block">
      <div class="p-text-center">ชื่อสมรรถนะ</div>
      <div class="p-text-center">(Compentency Name)</div>
    </div>
    <div class="p-col-3 title-block">
      <div class="p-grid title-block">
        <div class="p-col-12 p-text-center">คะแนนการประเมิน (มองภาพรวม)</div>
      </div>

      <div class="p-grid p-mt-0">
        <div class="p-col-6 p-text-center title-block">ประเมินโดยพนักงาน</div>
        <div class="p-col-6 p-text-center title-block">
          ประเมินโดยผู้บังคับบัญชา
        </div>
      </div>
    </div>
    <div class="p-col-4 title-block">
      <div class="p-text-center">บันทึก STAR</div>
      <div class="p-text-center">(กรณีประเมิน 5-6 )</div>
    </div>
  </div>
  <div v-for="(item, i) of items" :key="i">
    <div class="p-grid">
      <div class="p-col-5 title-block">
        <div class="p-grid">
          <div class="p-col-1">
            {{ item.abbrv }}
          </div>
          <div class="p-col-11 p-text-bold">
            {{ item.desc }}

            <div v-for="task of item.taskDescs" :key="task.taskDesc">
              <ul>
                <li class="p-text-normal">{{ task.taskDesc }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-3 title-block">
        <div class="p-grid">
          <div class="p-col-6">
            <InputNumber min="0" max="6" class="p-fluid"> </InputNumber>
          </div>
          <div class="p-col-6">
            <InputNumber minV="0" max="6"> </InputNumber>
          </div>
        </div>
      </div>
      <div class="p-col-4 title-block">
        <div class="p-grid">
          <div class="p-col-2">S =</div>
          <div class="p-col-10">
            <InputText type="text"> </InputText>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-2">T =</div>
          <div class="p-col-10">
            <InputText type="text"> </InputText>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-2">A =</div>
          <div class="p-col-10">
            <InputText type="text"> </InputText>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-2">R =</div>
          <div class="p-col-10">
            <InputText type="text"> </InputText>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import InputText from "primevue/inputtext";
import Divider from "primevue/divider";
export default defineComponent({
  name: "CompentencyHeaderTitle",
  props: {
    items: Array as PropType<any[]>,
  },
  setup(props) {
    console.log("items " + props.items);
  },
});
</script>

<style scoped>
.title-block {
  border: 0.5px solid #999;
}
</style>
